import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-stop-icon',
  templateUrl: './code-stop.component.html'
})
export class CodeStopComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
